<script lang='ts'>
    export let option: Option;
    export let selectedOptions: boolean[];
    export let dish: Dish;
</script>

<div class="eachOption">
    <label class="container" data-testid={"option " + option.name}>
        {option.name}
        <input type="checkbox" bind:checked={selectedOptions[dish.options.indexOf(option)]} class="checkbox" />
        
        <span class="checkmark">
            <span data-testid={"option_name " + option.name} class="dish_name">{option.name}</span>
            <span data-testid={"option_price " + option.name} class="dish_price">
                {#if option.price >= 0}
                    +
                {:else}
                    -
                {/if}
                ${Math.abs(option.price).toFixed(2)}
            </span>
        </span>
    </label>
</div>


<style>    
    .dish_name{
        position: relative;
    
        top: 3px;
        left: 33px;
    }
    
    .dish_price{
    
        display: block;
        float: right;
    
        position: relative;
        top: 3px;
        right: 5px;
    
    }
    
    .eachOption{
        margin: 5px auto;
    }
    
    /* The container */
    .container {
      display: block;
      position: relative;
      padding-left: 35px;
      margin-bottom: 18px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    
    /* Hide the browser's default checkbox */
    .container input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    
    /* Create a custom checkbox */
    .checkmark {
      position: absolute;
      top: -6px;
      left: 0;
    
      height: 25px;
      width: 100%;
    
      background-color: #f2f8fe;
      border: 2px solid var(--primary-colour);
      border-radius: 8px;
    }
    
    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
      background-color: #ccc;
    }
    
    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
      background-color: var(--primary-colour);
      color: white;
    }
    
    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }
    
    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
      display: block;
    }
    
    /* Style the checkmark/indicator */
    .container .checkmark:after {
      left: 9px;
      top: 5px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }    
</style>
    
    